import { Routes, Route } from 'react-router-dom'
import { ToastProvider } from './contexts/ToastContext'
import ToastContainer from './components/Toast'
import AppVersionNotifier from './components/AppVersionNotifier'
import AppNavigatorBridge from './components/AppNavigatorBridge'
import AppLayout from './layouts/AppLayout'
import RequireAuth from './components/RequireAuth'
import { AuthorizationProvider } from './contexts/AuthorizationContext'
import NotFound from './pages/NotFound'
import Unauthorized from './pages/Unauthorized'
import ProjectStatusSharedPage from './pages/public/ProjectStatusSharedPage'
import McpAuthorizePage from './features/mcp/authorize/page'
import { authRouteConfig, HomeRedirect } from './features/auth/routing'
import { renderProtectedRoutes } from './routes/protected'

export default function App() {
  return (
    <ToastProvider>
      <AppVersionNotifier />
      <AppNavigatorBridge />
      <Routes>
        {authRouteConfig.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}
        <Route path="/client/:clientId/projectstatus" element={<ProjectStatusSharedPage />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
        {/* Claude's sign-in lands here. Signed-in only, but outside AppLayout: a bare consent card. */}
        <Route
          path="/mcp/authorize"
          element={
            <RequireAuth>
              <McpAuthorizePage />
            </RequireAuth>
          }
        />
        <Route
          element={
            <RequireAuth>
              <AuthorizationProvider>
                <AppLayout />
              </AuthorizationProvider>
            </RequireAuth>
          }
        >
          <Route path="/" element={<HomeRedirect />} />
          {renderProtectedRoutes()}
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
      <ToastContainer />
    </ToastProvider>
  )
}
